// import React from 'react';
// import { partners } from '../mockData';

// const Partners = () => {
//   // Duplicate partners for seamless loop
//   const duplicatedPartners = [...partners.brands, ...partners.brands, ...partners.brands];

//   return (
//     <section id="partners" className="py-20 px-6 bg-brand-blue-100 border-t border-brand-blue-200 overflow-hidden">
//       <div className="max-w-7xl mx-auto">
//         <p className="text-brand-blue-600 text-sm font-semibold text-center mb-12 tracking-wide uppercase">{partners.title}</p>
        
//         {/* Infinite Scroll Container - Moving Left */}
//         <div className="partners-scroll-left">
//           <div className="flex gap-16 items-center">
//             {duplicatedPartners.map((brand, index) => (
//               <div key={index} className="flex items-center justify-center flex-shrink-0">
//                 <div className="text-brand-blue-600 font-bold text-2xl hover:text-brand-blue-700 transition-colors cursor-pointer whitespace-nowrap">
//                   {brand.name}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Partners;

//FIX TERAKHIR
// import React from 'react';
// import { partners } from '@/mockData';

// const Partners = () => {
//   // Duplicate partners for seamless loop
//   const duplicatedPartners = [...partners.brands, ...partners.brands, ...partners.brands];

//   return (
//     // DIUBAH: Dihapus 'bg-brand-blue-100 border-t border-brand-blue-200'
//     <section id="partners" className="py-20 px-6 border-t border-gray-800 overflow-hidden">
//       <div className="max-w-7xl mx-auto">
//         {/* DIUBAH: Teks diubah menjadi terang 'text-gray-400' */}
//         <p className="text-gray-400 text-sm font-semibold text-center mb-12 tracking-wide uppercase">{partners.title}</p>
        
//         {/* Infinite Scroll Container - Moving Left */}
//         <div className="partners-scroll-left">
//           <div className="flex gap-16 items-center">
//             {duplicatedPartners.map((brand, index) => (
//               <div key={index} className="flex items-center justify-center flex-shrink-0">
//                 {/* DIUBAH: Teks diubah menjadi putih 'text-white' */}
//                 <div className="text-white font-bold text-2xl hover:text-gray-300 transition-colors cursor-pointer whitespace-nowrap">
//                   {brand.name}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Partners;

import React from 'react';
// DIUBAH: Memperbaiki path import dari '../mockData' menjadi '../mockData.js'
import { partners } from '../mockData.js';

const Partners = () => {
  // Duplicate partners for seamless loop
  const duplicatedPartners = [...partners.brands, ...partners.brands, ...partners.brands];

  return (
    // DIUBAH: Dihapus 'bg-brand-blue-100 border-t border-brand-blue-200'
    <section id="partners" className="py-20 px-6 border-t border-gray-800 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {/* DIUBAH: Teks diubah menjadi terang 'text-gray-400' */}
        <p className="text-gray-400 text-sm font-semibold text-center mb-12 tracking-wide uppercase">{partners.title}</p>
        
        {/* Infinite Scroll Container - Moving Left */}
        <div className="partners-scroll-left">
          <div className="flex gap-16 items-center">
            {duplicatedPartners.map((brand, index) => (
              // DIUBAH: Menambahkan 'group' untuk hover effect dan 'cursor-pointer'
              <div key={index} className="flex items-center justify-center flex-shrink-0 cursor-pointer group">
                
                {/* --- TAMBAHAN: Logika untuk menampilkan logo --- */}
                {brand.logoUrl && (
                  <img
                    src={brand.logoUrl}
                    alt={brand.name}
                    // DIUBAH: Filter CSS (grayscale, brightness, invert) dan group-hover:filter-none dihapus
                    // Logo akan tampil apa adanya (original)
                    className="h-8 md:h-10 w-auto mr-4 transition-all duration-300"
                    // Tambahkan onError untuk menyembunyikan gambar jika gagal dimuat
                    onError={(e) => e.currentTarget.style.display = 'none'}
                  />
                )}
                {/* --- AKHIR TAMBAHAN --- */}

                {/* DIUBAH: Teks diubah menjadi putih 'text-white' dan hover dari 'group' */}
                <div className="text-white font-bold text-2xl group-hover:text-gray-300 transition-colors whitespace-nowrap">
                  {brand.name}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;